<template>


  <div class="wrapper">

    <v-sidebar activeNavItem="shipment"></v-sidebar>

    <div class="main-panel">

      <v-navbar v-bind:title="'Shipment Tracking'" path="/shipment" />

      <div class="content">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-md-12">

                    <h4>Tracking details</h4>
                    <small class='text-muted'>Id: {{id}}</small><br>
                    <small class='text-muted'>Shipper address: {{shipperAddress}}</small><br>
                    <small class='text-muted'>Consignee address: {{consigneeAddress}}</small><br>

                    <LeafletMap v-if="showMap" height="500px" :starting-center="[mapCenter.lat, mapCenter.lng]" :points="trackingPoints" :lines="lines" fitToMarkers/>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="legend-gps"></div> <small class='text-muted'>GPS Points</small>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="legend-estimate"></div> <small class='text-muted'>Estimate Route</small>

                      </div>
                    </div>

                    <router-link to="/shipment/view" class="nav-link">Back to Shipments</router-link>
                  </div>
              </div>
          </div>
      </div>

      <v-footer></v-footer>

    </div>

  </div>


</template>

<script>
import router from '../../router'
import apiService from '../../services/api.service'
import Vue from 'vue'
import config from '../../config'
import dateformat from 'dateformat'

import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'
import LeafletMap from '../map/LeafletMap'

import polyline from '@mapbox/polyline';

var rows = [];

const format = date => date && date.getTime() > 0 ? dateformat(date, "yyyy-mm-dd HH:MM") : '';

export default {
  name: 'ShipmentTracking',
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer,
    LeafletMap
  },

  data: function () {
    return {
      id: this.$route.params.id,
      shipperAddress: "",
      consigneeAddress: "",
      shipperCoords: null,
      consigneeCoords: null,
      pickupTime: '',
      deliveryTime: '',
      manualPickupTime: false,
      manualDeliveryTime: false,
      mapCenter: null,
      trackingPoints: [],
      estimatePoints: [],
      lines: [],
      showMap: false
    }
  },
  async mounted() {
    console.log("----mounted ");
    try {
      const response = await apiService.get(`/kong/api/v1/shipment/data/${this.id}`);
      if(!response || !response.data || !response.data.Result) return;
      const result = response.data.Result;
      this.setRfqData(result.rfq);
      this.setTrakingData(result.tracking, result.rfq);
      this.showMap = true;
    } catch (error) {
      console.log("failed", error)
    }
  },
  computed: {
    manualPickup() {
      return this.manualPickupTime ? "<br>(set manually)" : "";
    },
    manualDelivery() {
      return this.manualDeliveryTime ? "<br>(set manually)" : "";
    }
  },
  methods: {
    setRfqData(rfq) {
      if(!rfq) return;
      if(rfq.shipper) {
        this.shipperAddress = rfq.shipper.address;
        this.shipperCoords = rfq.shipper.addressCoordinates;
        
      }
      if(rfq.consignee) {
        this.consigneeAddress = rfq.consignee.address;
        this.consigneeCoords = rfq.consignee.addressCoordinates;
      }

      if(this.shipperCoords && this.consigneeCoords) {
        this.mapCenter = {
          lat: (this.shipperCoords.lat + this.consigneeCoords.lat) / 2,
          lng: (this.shipperCoords.lng + this.consigneeCoords.lng) / 2,
        }
      }

      const dispatch = rfq.dispatch;
      if(dispatch) {
        this.pickupTime = format(new Date(dispatch.actualPickupTime));
        this.deliveryTime = format(new Date(dispatch.actualDeliveryTime));
        this.manualPickupTime = dispatch.manualPickupTime;
        this.manualDeliveryTime = dispatch.manualDeliveryTime;

        if(dispatch.estimatePolyline) {
          this.estimatePoints = polyline.decode(dispatch.estimatePolyline);
          console.log("Estimate Points", this.estimatePoints);
        }
      }
    },
    setTrakingData(tracking, rfq) {
      if(!tracking) return;

      this.trackingPoints = [];
      if(this.shipperCoords) {
        this.trackingPoints.push({
          center: [this.shipperCoords.lat, this.shipperCoords.lng],
          tooltip: `${this.shipperAddress}<br>${this.pickupTime}${this.manualPickup}`,
          zIndexOffset: 1000,
          icon:{
            prefix: 'fa',
            icon: 'level-up',
            markerColor: 'green',
          }
        });
      }
      this.trackingPoints = this.trackingPoints.concat(tracking.map(point => {
        return {
          center: [point.latitude, point.longitude],
          tooltip: format(new Date(point.collectTime)),
        }
      }));
      if(this.consigneeCoords) {
        this.trackingPoints.push({  
          center: [this.consigneeCoords.lat, this.consigneeCoords.lng],
          tooltip: `${this.consigneeAddress}<br>${this.deliveryTime}${this.manualDelivery}`,
          zIndexOffset: 1000,
          icon:{
            prefix: 'fa',
            icon: 'level-down',
            markerColor: 'red',
          }
        });
      }

      const pointList = this.trackingPoints.map(point => point.center);

      // removes pickup point from lines if not picked up
      if(!serverTimeToLocal(rfq.dispatch.actualPickupTime)) pointList.shift();
      // removes delivery point from lines if not delivered
      if(rfq.dispatchStatus !== "Delivered") pointList.pop();

      const realPointLines = {
        pointList,
        options:{
          color: 'blue',
          weight: 2,
          opacity: 1,
          smoothFactor: 1
        },
      };

      this.lines = [
        realPointLines
      ];

      if(this.estimatePoints && this.estimatePoints.length) {
        this.lines.push({
          pointList: this.estimatePoints,
          options: {
            color: 'red',
            weight: 5,
            opacity: 0.5,
            smoothFactor: 1
          },
        });
      }
    }
  }
}
</script>

<style>
.legend-gps {
  width: 30px;
  height: 4px;
  display: inline-block;
  background-color: blue;
}

.legend-estimate {
  width: 30px;
  height: 8px;
  display: inline-block;
  background-color: red;
  opacity: 0.5;
}
</style>


// WEBPACK FOOTER //
// ShipmentTracking.vue?3732bd1e